import { createContext, useContext, useEffect } from 'react';

// 强制深色主题：不再支持切换/系统跟随。
// 保留 hooks 接口防止其它组件 import 出错，但永远返回 dark / no-op。
const ThemeContext = createContext('dark');
export const useTheme = () => useContext(ThemeContext);

const SetThemeContext = createContext(() => {});
export const useSetTheme = () => useContext(SetThemeContext);

const AutoThemeContext = createContext({
  theme: 'dark',
  storedTheme: 'dark',
  systemTheme: 'dark',
});
export const useAutoTheme = () => useContext(AutoThemeContext);

const FIXED_THEME = {
  theme: 'dark',
  storedTheme: 'dark',
  systemTheme: 'dark',
};

const noopSetTheme = () => {};

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.body.setAttribute('theme-mode', 'dark');
    // 清理旧的 localStorage 偏好，避免误导
    try {
      localStorage.removeItem('theme-mode');
    } catch {
      // ignore
    }
  }, []);

  return (
    <AutoThemeContext.Provider value={FIXED_THEME}>
      <SetThemeContext.Provider value={noopSetTheme}>
        <ThemeContext.Provider value="dark">{children}</ThemeContext.Provider>
      </SetThemeContext.Provider>
    </AutoThemeContext.Provider>
  );
};
